import { get } from "lodash-es"

function getList(object) {
  const keys = Object.keys(object)
  const firstKey = keys[0]
  return get(object, firstKey, [])
}

export default getList
